<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-text-field append-icon="search" label="" single-line hide-details :placeholder="$t('private_global.filter')" v-model="search"></v-text-field>
      <v-data-table :headers="headers" :items="invoices" :rows-per-page-text="$t('global_tables_rows_page')" :rows-per-page-items="rowsPerPageItems" :search="search">
        <template slot="items" slot-scope="props">
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.period }}</td>
          <td class="justify-center layout px-0" v-if="props.item.name !== '-'">
            <v-btn outline fab small color="primary" @click="downloadBillings(props.item.code)">
              <v-icon color="primary">file_download</v-icon>
            </v-btn>
          </td>
        </template>
        <template slot="no-data">
          <v-alert :value="true" outline color="info" v-html="$t('private_dash_table_earnings_nodata')"> </v-alert>
        </template>
        <template slot="pageText" slot-scope="props"> {{ props.pageStart }} - {{ props.pageStop }} {{ $t('global_table_from_of_preposition') }} {{ props.itemsLength }} </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import { EventBus } from '@/services/eventBus';
import billingService from '@/services/billingService';
import _ from 'lodash';
import keys from '@/store/keys';

export default {
  name: 'invoices-table-box',
  props: ['parkingId'],
  components: {},
  data() {
    return {
      rowsPerPageItems: [25, 50, 100, { text: this.$i18n.t('row_pagination_all'), value: -1 }],
      invoices: [
        {
          period: '-',
          name: '-',
          code: '-',
          id: '-'
        }
      ],
      isLoading: false,
      search: [],
      headers: [
        {
          i18nText: 'private_parking_invoices_table_description',
          text: this.$i18n.t('private_parking_invoices_table_description'),
          align: 'left',
          value: 'name',
          sortable: false
        },
        {
          i18nText: 'private_parking_invoices_table_date',
          text: this.$i18n.t('private_parking_invoices_table_date'),
          align: 'left',
          value: 'period'
        },
        {
          i18nText: '',
          text: '',
          align: '',
          value: ''
        }
      ]
    };
  },
  created() {
    EventBus.$on(keys.eventOnLanguageChanged, this.updateTableLables);
    this.loadData();
  },
  destroyed() {
    EventBus.$off(keys.eventOnLanguageChanged, this.updateTableLables);
  },
  methods: {
    updateTableLables() {
      _.each(this.headers, itInvoiceDatTable => {
        itInvoiceDatTable.text = this.$i18n.t(itInvoiceDatTable.i18nText);
      });
      this.rowsPerPageItems = [25, 50, 100, { text: this.$i18n.t('row_pagination_all'), value: -1 }];
    },
    loadData() {
      this.updateTableLables();
      let params = {
        parking: this.parkingId
      };
      billingService.list(params, this.billingListSuccessHandler, this.billingListErrorHandler);
    },
    billingListSuccessHandler(data) {
      this.invoices = _.orderBy(
        data,
        itData => {
          return itData.period;
        },
        'asc'
      );
    },
    billingListErrorHandler() {},
    downloadBillings(code) {
      let params = {
        parkingId: this.parkingId,
        code: code
      };
      this.isLoading = true;
      billingService.download(params, this.downloadSuccessHandler, this.downloadErrorHandler);
    },
    downloadSuccessHandler(data) {
      this.isLoading = false;
      EventBus.$emit(keys.eventOnShowNotification, {
        title: '',
        message: data[0],
        type: 'accent',
        doNotTranslate: true
      });
    },
    downloadErrorHandler(data) {
      this.isLoading = false;
      EventBus.$emit(keys.eventOnShowNotification, {
        title: '',
        message: data,
        type: 'error',
        doNotTranslate: true
      });
    }
  }
};
</script>
<style lang="scss" scoped>
h1.table-title,
.panel .panel-heading .panel-title {
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 0;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/commons/InvoicesTableBox.vue